define('modules/integrations/services/shopify/model',['require','exports','module','env','base/model'],function (require, exports, module) {
  "use strict";

  var Config = require("env");
  var BaseModel = require("base/model");

  var model = BaseModel.extend({
    groupId: null,

    initialize: function () {
      this.initRequestEvents();
    },

    url: function () {
      var url = Config.backendUrl + "/integrations/companies",
        groupId = this.groupId;

      return url + "/" + groupId;
    },

    setGroupId: function (groupId) {
      this.groupId = groupId;

      return this;
    },
  });

  module.exports = model;
});

